import profetional_resume_1 from "../image/technical_Image/profetional_resume_1.webp";
import profetional_resume_2 from "../image/technical_Image/profetional_resume_2.webp";
import profetional_resume_3 from "../image/technical_Image/profetional_resume_3.webp";
import profetional_resume_4 from "../image/technical_Image/profetional_resume_4.webp";
import profetional_resume_5 from "../image/technical_Image/profetional_resume_5.webp";
import profetional_resume_6 from "../image/technical_Image/profetional_resume_6.webp";
import profetional_resume_7 from "../image/technical_Image/profetional_resume_7.webp";

import Basic_Ats_Resume_Template from "../image/technical_Image/Basic_Ats_Resume_Template.webp";
import Creative_ATS_Resume_Template from "../image/technical_Image/Creative-ATS-Resume-Template.webp";
import Executive_ATS_Resume_Template from "../image/technical_Image/Executive-ATS-Resume-Template.webp";
import Functional_ATS_Resume_Template from "../image/technical_Image/Functional-ATS-Resume-Template.webp";
import Minimalist_ATS_Resume_Template from "../image/technical_Image/Minimalist-ATS-Resume-Template.webp";
import Modern_ATS_Resume_Template from "../image/technical_Image/Modern-ATS-Resume-Template.webp";
import Simple_ATS_Resume_Template from "../image/technical_Image/Simple-ATS-Resume-Template.webp";
import Tech_ATS_Resume_Template from "../image/technical_Image/Tech-ATS-Resume-Template.webp";
import Traditional_ATS_Resume_Template from "../image/technical_Image/Traditional-ATS-Resume-Template.webp";
import Bank_Resume_Format_for_Freshers_PDF from "../image/technical_Image/banking-resume-example.webp";

export const techImages = [
  { id: 101, src: profetional_resume_1, alt: "AutoCAD Resume" },
  { id: 102, src: profetional_resume_2, alt: "Manager Resume" },
  { id: 103, src: profetional_resume_3, alt: "Professional Resume 3" },
  { id: 104, src: profetional_resume_4, alt: "Hospital Resume 1" },
  { id: 105, src: profetional_resume_5, alt: "Hospital Resume 2" },
  { id: 106, src: profetional_resume_6, alt: "Hospital Resume 3" },
  { id: 107, src: profetional_resume_7, alt: "Hospital Resume 4" },
  { id: 108, src: Basic_Ats_Resume_Template, alt: "Basic ATS Resume Template" },
  { id: 109, src: Creative_ATS_Resume_Template, alt: "Creative ATS Resume" },
  { id: 110, src: Executive_ATS_Resume_Template, alt: "Executive ATS Resume" },
  { id: 111, src: Functional_ATS_Resume_Template, alt: "Functional ATS Resume" },
  { id: 112, src: Minimalist_ATS_Resume_Template, alt: "Minimalist ATS Resume" },
  { id: 113, src: Modern_ATS_Resume_Template, alt: "Modern ATS Resume" },
  { id: 114, src: Simple_ATS_Resume_Template, alt: "Simple ATS Resume" },
  { id: 115, src: Tech_ATS_Resume_Template, alt: "Tech ATS Resume" },
  { id: 116, src: Traditional_ATS_Resume_Template, alt: "Traditional ATS Resume" },
  { id: 117, src: Bank_Resume_Format_for_Freshers_PDF, alt: "Bank Resume for Freshers" },
];